var ansi = require('an-ansi');
var formatDate = require('an-format-date');
var levels = require('./levels.js');
var worker;

if (typeof window ==='undefined') {
  var cluster = require('clu'+'ster');
  worker = cluster.worker;
}

/**
 * Un renderer text qui colore la sortie suivant le level
 * @param config
 * @param record
 */
function ansiRenderer(config, record) {
  var prefix = record.name;
  var currentLogLevel = config.logLevel || levels.INFO
  if (record.level && record.level > currentLogLevel) return
  var output;
  switch(record.level) {
    case levels.DEBUG:
      prefix = ansi.blue(prefix) + '+'+record.delay+'ms';
      output = console.log;
      break;

    case levels.ERROR:
      prefix = ansi.red(prefix);
      output = console.error;
      break;

    case levels.WARNING:
      prefix = ansi.yellow(prefix);
      output = console.error;
      break;

    default:
      prefix = ansi.green(prefix);
      output = console.log;
      break;
  }
  var args = record.args.slice(0);
  if (record.level===levels.INFO && record.verb) {
    args.unshift(ansi.magenta(record.verb));
  }
  args.unshift(prefix);
  if (worker) {
    args.unshift(ansi.blue(worker.id));
  }
  args.unshift(ansi.gray(formatDate(record.timestamp, '%d/%M %H:%m:%s')));
  output.apply(console, args);
}

module.exports = {
  name: 'ansi',
  build: function (config) {
    // on garde le dynamisme sur config
    return function(log) {
      ansiRenderer(config, log);
    }
  }
}
